var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageLogoBifi = function SvgImageLogoBifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    d: "M14.06 11.783c.335 0 .645.18.813.47l13.002 22.52a.94.94 0 0 1-.812 1.408H1.058a.938.938 0 0 1-.813-1.407l13.002-22.522a.94.94 0 0 1 .813-.469M2.683 34.304h22.754L14.06 14.598z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    d: "M14.046 11.783c.519 0 .939.42.939.939v14.116l12.361 7.417a.938.938 0 0 1-.965 1.61l-12.335-7.401-12.334 7.4a.938.938 0 1 1-.965-1.61l12.361-7.416V12.722c0-.519.42-.939.938-.939",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M38.533 35V12.375h9.688c5.156 0 7.875 2.219 7.875 5.688 0 2.5-1.781 4.406-4.344 4.937v.219c2.844.093 5.219 2.187 5.219 5.406 0 3.688-3 6.375-7.938 6.375zm8.969-4.781c2.125 0 3.188-.813 3.188-2.344 0-1.656-1.188-2.594-3.094-2.594H44.47v4.938zm-.375-8.657c1.656 0 2.844-.812 2.844-2.25s-1.125-2.25-2.75-2.25h-2.75v4.5zM59.315 35V18.031h5.906V35zm2.937-18.812c-1.625 0-2.937-1.22-2.937-2.72s1.312-2.718 2.937-2.718 2.937 1.219 2.937 2.719-1.312 2.719-2.937 2.719M68.314 35V12.375h15.782v4.813h-9.844v4.093h8.844v4.813h-8.844V35zm18.22 0V18.031h5.905V35zm2.937-18.812c-1.625 0-2.938-1.22-2.938-2.72s1.313-2.718 2.938-2.718 2.937 1.219 2.937 2.719-1.312 2.719-2.937 2.719"
  })));
};
export default SvgImageLogoBifi;